var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showRemove)?_c('li',{on:{"click":_vm.remove}},[_c('v-icon',{attrs:{"left":"","color":"red"}},[_vm._v("$vuetify.icons.trash")]),_c('span',[_vm._v("Odebrat bod")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }